// dev/app-skeleton/src/lib/session-key.ts
// 内存中的 root_key 管理：解锁后驻留，空闲 5min 锁；切后台 30s 延迟锁（防误锁），回前台清 timer；
// D14-DEV-v2 / SEC C' 修：
//   - 删 pagehide→lock：iOS Safari/手势会触发 pagehide，会把刚解锁立刻锁回（UX bug B 根因）
//   - visibilitychange hidden 改"30s 延迟"，30s 内回前台自动撤销，纯切后台不再被错杀
//   - 锁定/解锁都做对称清理
import { AUTO_LOCK_IDLE_MS, deriveSubKey, infoBytes, zeroize } from "../crypto";
const HIDDEN_LOCK_DELAY_MS = 30_000;
let rootKey = null;
let idleTimer = null;
let hiddenTimer = null;
let lastActivity = 0;
const listeners = [];
export function setRootKey(k) {
    if (rootKey)
        zeroize(rootKey);
    rootKey = k;
    touch();
    notify(true);
    // 仅订阅 visibilitychange；pagehide 在 iOS / 手势导航下会误触发 → 删除
    if (typeof document !== "undefined") {
        document.addEventListener("visibilitychange", onVisibilityChange);
    }
}
export function getRootKey() {
    if (!rootKey)
        throw new Error("locked: root_key not in memory");
    touch();
    return rootKey;
}
export function isUnlocked() {
    return rootKey != null;
}
export function lock() {
    if (rootKey)
        zeroize(rootKey);
    rootKey = null;
    if (idleTimer) {
        clearTimeout(idleTimer);
        idleTimer = null;
    }
    if (hiddenTimer) {
        clearTimeout(hiddenTimer);
        hiddenTimer = null;
    }
    notify(false);
    if (typeof document !== "undefined") {
        document.removeEventListener("visibilitychange", onVisibilityChange);
    }
}
export function onLockChange(fn) {
    listeners.push(fn);
    return () => { const i = listeners.indexOf(fn); if (i >= 0)
        listeners.splice(i, 1); };
}
function notify(state) { for (const fn of listeners)
    fn(state); }
/** 隐藏 → 起 30s 定时；回前台清掉，防误锁。 */
function onVisibilityChange() {
    if (typeof document === "undefined")
        return;
    if (document.visibilityState === "hidden") {
        if (hiddenTimer)
            clearTimeout(hiddenTimer);
        hiddenTimer = setTimeout(() => {
            hiddenTimer = null;
            if (document.visibilityState === "hidden" && rootKey)
                lock();
        }, HIDDEN_LOCK_DELAY_MS);
    }
    else {
        if (hiddenTimer) {
            clearTimeout(hiddenTimer);
            hiddenTimer = null;
        }
    }
}
function touch() {
    lastActivity = Date.now();
    if (idleTimer)
        clearTimeout(idleTimer);
    idleTimer = setTimeout(() => {
        if (Date.now() - lastActivity >= AUTO_LOCK_IDLE_MS)
            lock();
    }, AUTO_LOCK_IDLE_MS);
}
/** 便捷：派生指定用途的子密钥 */
export function deriveFromRoot(kind, resourceId = "") {
    return deriveSubKey(getRootKey(), infoBytes(kind, resourceId));
}
